import isotipeUrl from "../assets/berryloo_isotipe.svg";

// Isotipo (sin wordmark), archivo fuente real en src/assets/berryloo_isotipe.svg
// (CLAUDE.md §5: "usar este archivo directamente... no recrearlo con
// CSS/SVG a mano") — se importa como asset e imprime vía <img>, no se
// transcriben los paths a mano (son ~25, alto riesgo de error de
// transcripción).
interface BerryIconProps {
  size?: number;
}

export default function BerryIcon({ size = 22 }: BerryIconProps) {
  return <img src={isotipeUrl} width={size} height={size} alt="" />;
}
